import { normalizeToSelect } from '@unicus/react-ui-kit';

const cityNormalizeToSelect = (city) => {
  return normalizeToSelect(city, {
    label: (c) => {
      return `${c.name} - ${c.state?.toUpperCase()}`;
    }
  });
};

export default cityNormalizeToSelect;
